export enum MyConferenceTypes {
  LIST_MY_CONFERENCE = '@conference/LIST_MY_CONFERENCE',
  LIST_MY_CONFERENCE_SUCCESS = '@conference/LIST_MY_CONFERENCE_SUCCESS',
  LIST_MY_CONFERENCE_FAILED = '@conference/LIST_MY_CONFERENCE_FAILED',
}
